import { ChakraProvider, extendTheme } from '@chakra-ui/react'
import { QueryClientProvider } from '@tanstack/react-query' // QueryClient import removed
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
// Import the shared queryClient
import { modalTheme } from './components/features/properties/StaysPropertyForm/components/ConfirmationModal/modalTheme.ts'
import { queryClient } from './lib/react-query/query-client'

const theme = extendTheme({
  styles: {
    global: {
      body: {
        bg: 'gray.50',
        minHeight: '100vh',
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        _hover: {
          transform: 'translateY(-1px)',
          boxShadow: 'sm',
        },
        _active: {
          transform: 'translateY(0)',
        },
        transition: 'all 0.2s',
      },
    },
    Modal: modalTheme,
  },
})

// const queryClient = new QueryClient(); // Remove local instantiation

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ChakraProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        {' '}
        {/* Use imported queryClient */}
        <App />
        {/* Conditionally render ReactQueryDevtools */}
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </ChakraProvider>
  </StrictMode>
)
